import { render, staticRenderFns } from "./ParleyReport.vue?vue&type=template&id=4bf8d1a5&"
import script from "./ParleyReport.vue?vue&type=script&lang=js&"
export * from "./ParleyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports